import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import AuthDialog from "./AuthDialog";
import Avatar from "./Avatar";
import ProfileModal from "./ProfileModal";
import SPORT from "../sport/config";

export default function Header({ children, onLogoClick }) {
  const { user, profile, isAdmin } = useAuth();
  const [authMode, setAuthMode] = useState(null);
  const [profileOpen, setProfileOpen] = useState(false);

  const logo = (
    <img
      src={`${process.env.PUBLIC_URL}/${SPORT.logoFile}`}
      alt={SPORT.siteName}
      className="h-9 md:h-12 w-auto"
    />
  );

  return (
    <>
      <header className="px-4 md:px-6 py-3 md:py-4 border-b border-zinc-900 flex items-center justify-between gap-2 shrink-0">
        {onLogoClick ? (
          <button
            type="button"
            onClick={onLogoClick}
            className="flex items-center group shrink-0"
          >
            {logo}
          </button>
        ) : (
          <Link to="/" className="flex items-center group shrink-0">
            {logo}
          </Link>
        )}

        <div className="flex items-center gap-2 md:gap-3 min-w-0">
          {children}

          {user ? (
            <div className="flex items-center gap-2 min-w-0">
              {isAdmin && (
                <Link
                  to="/admin"
                  title="Admin dashboard"
                  className="px-2.5 py-1.5 rounded-lg text-xs font-semibold text-emerald-300
                             bg-emerald-500/10 border border-emerald-500/30 hover:bg-emerald-500/20 transition shrink-0"
                >
                  Admin
                </Link>
              )}
              <button
                type="button"
                onClick={() => setProfileOpen(true)}
                className="flex items-center gap-2 px-1.5 md:px-2 py-1 rounded-lg hover:bg-zinc-900 transition min-w-0"
                title="Open profile"
              >
                <span className="text-xs text-zinc-200 font-semibold max-w-[80px] md:max-w-[160px] truncate">
                  {profile?.username || user.email}
                </span>
                <Avatar
                  username={profile?.username}
                  email={user.email}
                  url={profile?.avatar_url}
                  size={28}
                />
              </button>
            </div>
          ) : (
            <>
              <button
                onClick={() => setAuthMode("signin")}
                className="text-xs font-semibold text-zinc-300 hover:text-zinc-100 transition shrink-0"
              >
                Sign in
              </button>
              <button
                onClick={() => setAuthMode("signup")}
                className="px-3 md:px-4 py-2 rounded-full bg-emerald-500 text-zinc-950 font-semibold text-sm hover:bg-emerald-400 transition shrink-0"
              >
                Sign up
              </button>
            </>
          )}
        </div>
      </header>

      <AuthDialog
        open={authMode !== null}
        initialMode={authMode || "signin"}
        onClose={() => setAuthMode(null)}
      />
      <ProfileModal open={profileOpen} onClose={() => setProfileOpen(false)} />
    </>
  );
}
